import React, { useEffect, useState } from "react";
import { get_types_list } from "../../../../../DAL/features/features";
import { useParams } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import CircularLoader from "../../../../../components/loader/CircularLoader";
import { useIds } from "../../../../../hook/AdminContext";

export default function CoachesFilter({ inputs, setInputs }) {
  const { userInfo } = useIds();
  const [loading, setLoading] = useState(true);
  const { feature_slug } = useParams();
  const [typesList, setTypesList] = useState([]);

  const handleGetTypesAgainstFeatures = async () => {
    const resp = await get_types_list(feature_slug);
    if (resp.code == 200) {
      setTypesList(resp.data);
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
    }
    setLoading(false);
  };

  const findObjectWithId = (id, list) => {
    return list.find((obj) => obj._id == id);
  };
  const handleChange = (e, list) => {
    const { name, value } = e.target;

    if (list) {
      let obj = findObjectWithId(value, list);
      setInputs((old) => ({ ...old, [name]: obj }));
    } else {
      setInputs((old) => ({ ...old, [name]: value }));
    }
  };
  useEffect(() => {
    handleGetTypesAgainstFeatures();
  }, []);

  if (loading) {
    return <CircularLoader height="150px" />;
  }

  return (
    <>
      <h6>Select Type</h6>
      <FormControl fullWidth required className="mt-2">
        <InputLabel id={`sector-select-feature_type`}>Type</InputLabel>
        <Select
          labelId={`sector-select-feature_type`}
          id={`sector-select-feature_type`}
          value={inputs?.type?._id || "all"}
          required
          name="type"
          label={`Type`}
          onChange={(e) => handleChange(e, typesList)}
        >
          <MenuItem key={"all"} value={"all"}>
            All Types
          </MenuItem>
          {typesList.map((type) => (
            <MenuItem key={type._id} value={type._id}>
              {type.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
}
